var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-side-menu", [
    _c(
      "aside",
      { staticClass: "menu", attrs: { slot: "side-menu" }, slot: "side-menu" },
      [
        _c("p", { staticClass: "menu-label" }, [
          _c("span", { staticClass: "title is-6" }, [_vm._v(" Filters ")]),
        ]),
        _c("ul", { staticClass: "menu-list" }, [
          _c("li", [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.innerValue.search,
                      expression: "innerValue.search",
                    },
                  ],
                  staticClass: "input is-uppercase",
                  attrs: { type: "text", placeholder: "Search..." },
                  domProps: { value: _vm.innerValue.search },
                  on: {
                    keyup: function ($event) {
                      return _vm.onFilterClick()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.innerValue, "search", $event.target.value)
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "help" }, [
                _vm._v(" Search by "),
                _c("ul", [
                  _c("li", [_vm._v("Quote No.")]),
                  _c("li", [_vm._v("Rego No.")]),
                  _c("li", [_vm._v("Customer Name/Phone")]),
                  _c("li", [_vm._v("Claim No.")]),
                  _c("li", [_vm._v("Car Make/Model.")]),
                ]),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "field",
                on: {
                  focusout: function ($event) {
                    return _vm.onFilterClick()
                  },
                },
              },
              [
                _c("v-date-picker", {
                  attrs: {
                    "is-dark": _vm.$theme.isDark,
                    masks: _vm.formats,
                    attributes: _vm.attrs,
                    "model-config": _vm.modelConfig,
                    locale: _vm.$userInfo.locale,
                    timezone: _vm.$filters.getIanaTimezone(),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ inputValue, inputEvents }) {
                        return [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "div",
                              { staticClass: "control has-icons-left" },
                              [
                                _c(
                                  "input",
                                  _vm._g(
                                    {
                                      staticClass: "input",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Date From...",
                                      },
                                      domProps: { value: inputValue },
                                    },
                                    inputEvents
                                  )
                                ),
                                _c(
                                  "span",
                                  { staticClass: "icon is-small is-left" },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-calendar mdi-18px",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selectedFromDate,
                    callback: function ($$v) {
                      _vm.selectedFromDate = $$v
                    },
                    expression: "selectedFromDate",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "field",
                on: {
                  focusout: function ($event) {
                    return _vm.onFilterClick()
                  },
                },
              },
              [
                _c("v-date-picker", {
                  attrs: {
                    "is-dark": _vm.$theme.isDark,
                    masks: _vm.formats,
                    attributes: _vm.attrs,
                    "model-config": _vm.modelConfig,
                    locale: _vm.$userInfo.locale,
                    timezone: _vm.$filters.getIanaTimezone(),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ inputValue, inputEvents }) {
                        return [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "div",
                              { staticClass: "control has-icons-left" },
                              [
                                _c(
                                  "input",
                                  _vm._g(
                                    {
                                      staticClass: "input",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Date To...",
                                      },
                                      domProps: { value: inputValue },
                                    },
                                    inputEvents
                                  )
                                ),
                                _c(
                                  "span",
                                  { staticClass: "icon is-small is-left" },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-calendar mdi-18px",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selectedToDate,
                    callback: function ($$v) {
                      _vm.selectedToDate = $$v
                    },
                    expression: "selectedToDate",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select is-fullwidth" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerValue.taskStatus,
                          expression: "innerValue.taskStatus",
                        },
                      ],
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.innerValue,
                              "taskStatus",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function ($event) {
                            return _vm.onFilterClick()
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "option",
                        { attrs: { selected: "selected", value: "" } },
                        [_vm._v("-- Status --")]
                      ),
                      _c("option", { attrs: { value: "new" } }, [
                        _vm._v("New"),
                      ]),
                      _c("option", { attrs: { value: "quote" } }, [
                        _vm._v("Quote"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select is-fullwidth" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerValue.taskType,
                          expression: "innerValue.taskType",
                        },
                      ],
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.innerValue,
                              "taskType",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function ($event) {
                            return _vm.onFilterClick()
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "option",
                        { attrs: { selected: "selected", value: "" } },
                        [_vm._v("-- Booking Type --")]
                      ),
                      _c("option", { attrs: { value: "repx" } }, [
                        _vm._v("Repx"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "buttons has-addons" }, [
              _c(
                "span",
                {
                  staticClass: "button",
                  class: {
                    "is-primary is-selected": _vm.innerValue.active === 0,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeActive(0)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-adjust" }),
                  ]),
                  _c("span", [_vm._v("Both")]),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "button",
                  class: {
                    "is-success is-selected": _vm.innerValue.active === 1,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeActive(1)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-check" }),
                  ]),
                  _c("span", [_vm._v("Active")]),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "button",
                  class: {
                    "is-danger is-selected": _vm.innerValue.active === 2,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeActive(2)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-close" }),
                  ]),
                  _c("span", [_vm._v("In-Active")]),
                ]
              ),
            ]),
          ]),
        ]),
        _c("hr"),
        _c("div", { staticClass: "field is-grouped is-pulled-right" }, [
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: { click: _vm.onFilterClick },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
                ]),
                _c("span", [_vm._v("Filter")]),
              ]
            ),
          ]),
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.onResetClick } },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-refresh mdi-18px" }),
                ]),
                _c("span", [_vm._v("Reset")]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }